import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";
// TODO : useHandleImageError 여기로 이관

/**
 * 
 * 종목 로고 이미지 반환
 * @param ticker 종목 코드
 * @returns 종목 로고 이미지
 */

export function getStockLogo(ticker: string) {
    return getPublicAssetUrl(`logos/${ticker}.png`) ||
        ERROR_LOGO_URL
}

